import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="9.6" height="9.602" viewBox="0 0 9.6 9.602" {...props}><path d="M4.8 0a4.801 4.801 0 010 9.6 4.8 4.8 0 110-9.6z" /></svg>);